import { render, staticRenderFns } from "./DefaultQuestionnaires.vue?vue&type=template&id=9370537c&"
import script from "./DefaultQuestionnaires.vue?vue&type=script&lang=js&"
export * from "./DefaultQuestionnaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports